import Button from '@/theme/foundations/components/button';
import Checkbox from '@/theme/foundations/components/checkbox';
import Input from '@/theme/foundations/components/input';

export default { Button, Input, Checkbox };
